export default {

    newAsset: 'Add Asset',
    relatedAssets: 'Related Assets',
    assets: 'Assets',
    noAssetsCategories: 'No Asset Categories',
    assetFromTemplate: 'System Assets',
    assetTemplate: 'System Asset',
    addAssetFromTemplate: 'Add Asset from System',
    selectAssetFromTemplate: 'Selecciona los activos existentes que tienen relación con tu organización y las vulnerabilidades y amenazas que apliquen',
    noDefaultAssets: 'sin activos por defecto',
    saveAssets: 'Save Assets',
    goToAssetCreation: 'Go to Asset Creation',
    noAssetsCategory: { single: 'No Asset Category', plural: 'No Asset Categories'},
    noAsset: 'The asset does not exist',
    noAssets: 'There are no assets',
    assetDescription: 'represents any valuable resource within your organization that must be protected. It can be a system, a database, confidential information, technological infrastructure, or even your employees’ knowledge.',
    assetCreationMessage: 'It\'s time to add your assets!',
    assetGuide: ' which includes default vulnerabilities and threats. If you prefer to add your own assets later, simply click on ',
    selectAssets: 'To get started, you can select assets from our',
    assetsManagement: 'Assets Management',
    asset: { single: 'Asset', plural: 'Assets'},
    assetCategory: { single: 'Asset category', plural: 'Asset categories'},
    noAssetCategory: { single: 'No Asset Category', plural: 'No Asset Categories'},
    noRegisteredAssets: 'You don\'t have any registered assets yet',
    importAssetsOrUseTemplate: 'You can import assets from a CSV file or add them using our pre-designed template.',
    exploreAssetsTemplate: 'I want to choose assets from a list',
    importExcelAssets: 'I want to import assets with a template',
    imReadyAssets: 'I want to add my assets manually',
    createNewAsset: 'Create new asset',
    assetTypeNotFound: { single: 'Asset type not found', plural: 'Asset types not found'},
    critical: 'Critical',
    notCritical: 'No Critical',
    noDefined: 'Undefined',
    assetLocation: { "single": "Location", "plural": "Locations" },
    assetLocationTooltip: "Physical or virtual place where the asset is located.",
    assetLocationPlaceholder: "Select a Location",
    assetLocationNotFound: { "single": "Location not found", "plural": "Locations not found" },
    custodian: { "single": "Custodian", "plural": "Custodians" },
    custodianTooltip: "Person or entity responsible for the management, protection, and control of the asset within the organization.",
    custodianPlaceholder: "Select a Custodian",
    custodianNotFound: { "single": "Custodian not found", "plural": "Custodians not found" },
    owner: { "single": "Owner", "plural": "Owners" },
    ownerTooltip: "Person or area of the organization that owns the asset.",
    ownerPlaceholder: "Select an Owner",
    ownerNotFound: { "single": "Owner not found", "plural": "Owners not found" },
    organizationalProcess: { "single": "Organizational Process", "plural": "Organizational Processes" },
    organizationalProcessTooltip: "Area or process of the organization to which the asset is associated.",
    organizationalProcessPlaceholder: "Select an Organizational Process",
    organizationalProcessNotFound: { "single": "Organizational process not found", "plural": "Organizational processes not found" },
    organizationalCategory: { "single": "Company Category", "plural": "Company Categories" },
    organizationalCategoryPlaceholder: "Select a Company Category",
    organizationalCategoryNotFound: { "single": "Company category not found", "plural": "Company categories not found" },
    personalDataQuestion: "Does the asset contain personal data?",
    evidenceLabel: "Evidence",
    evidenceEmpty: "No files associated",
    assetsCategoryTooltip: 'Categories allow you to differentiate an asset by different subtypes.',
    assetsSensitivityTooltip: 'Select the classification according to the sensitivity of the information.',
    assetCustodianTooltip: 'Person or entity responsible for the administration, protection and control of the asset within the organization.',
    assetOwnerTooltip: 'Person or area of the organization that owns the asset.',
    assetRelationshipGuide: 'Relacionar activos te permitirá identificar cómo se relacionan y afectan entre sí, facilitando la gestión de riesgos.',
    assetCriticality: 'Asset Criticity',
    notSure: 'I\'m not sure',
    criticalAsset: 'Critical Asset',
    securityRequirements: 'Security Requirements',
    assetImpactFactor: 'Asset Impact Factors',
    assetImpactFactorTooltip: 'Select the asset impact factors that apply according to its criticality.',
    criticalDetailsTooltip: 'Describe why this asset is considered critical to the organization, who depends on it, and what the impact would be if it failed.',
    securityRequirementsTooltip: 'Enter a description for at least one security requirement that applies to this asset (confidentiality, integrity, or availability).',
    criticalDetailsPlaceholder: 'Why is this asset considered critical? Who uses it? (0/500)',
    activate: 'Activate',
    createNewUbicationActive: 'Create new asset location',
    createNewCustodian: 'Create new custodian',
    createNewOwner: 'Create new owner',
    saveAsset: 'Save Asset'

};
